if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks,
    } = window.wp.editor;

    registerBlockType('custom-gutenberg/banner-container', {
        // built-in attributes
        title: 'Banner Container',
        description: 'Custom Banner Container',
        icon: '',
        category: 'custom-containers',
        example: {},

        // built-in functions
        edit() {

            const MY_TEMPLATE = [
                [ 'core/heading', { tagName: 'h2', textAlign: 'center', className: 'mb-2', placeholder: 'JEDINSTVENE PRILIKE' } ],
                [ 'core/paragraph', { tagName: 'p', align: 'center', className: 'lead mb-4', placeholder: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec ornare sapien eu est sociis phasellus hendrerit quam semper.' } ],
            ];

            return (
                <section class="featured-category-section">
                    <div class="container my-3 my-lg-5">
                        <InnerBlocks template={ MY_TEMPLATE } />
                    </div>
                </section>
            );
        },

        save() {

            return (
                <section class="featured-category-section">
                    <div class="container my-3 my-lg-5">
                        <InnerBlocks.Content />
                    </div>
                </section>
            );
        },
    });
}